// extracted by mini-css-extract-plugin
export var buttonContainer = "styles-module--buttonContainer--5A3+H";
export var container = "styles-module--container--hZKLd";
export var containerCenterLeft = "styles-module--containerCenterLeft--KZAYv";
export var containerTopLeft = "styles-module--containerTopLeft--5fY0e";
export var containerWithSubheading = "styles-module--containerWithSubheading--m7ICo";
export var desktop = "1340px";
export var downloadIcon = "styles-module--downloadIcon--qeWvj";
export var giant = "2200px";
export var header = "styles-module--header--Pvnnu";
export var headerHeading = "styles-module--headerHeading--Ynl1A";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";